import { useConfigStore } from 'src/stores/config'
import { configure, query } from 'vue-gtag'
import { router } from 'src/boot/router'
import { watch } from 'vue'

const Boot = () => {
  if (!import.meta.env.VITE_GA_MEASUREMENT_ID) {
    return
  }

  const config = useConfigStore()
  const additionalAccounts = config.tenant?.gaMeasurementId ? [{ tagId: config.tenant.gaMeasurementId }] : []

  const setConfig = () => {
    configure({
      tagId: import.meta.env.VITE_GA_MEASUREMENT_ID,
      pageTracker: {
        router,
      },
      additionalAccounts,
    })
  }
  setConfig()

  console.log(
    `Enabled GA4 with measurement IDs ${import.meta.env.VITE_GA_MEASUREMENT_ID}` +
      (config.tenant?.gaMeasurementId ? `, ${config.tenant.gaMeasurementId}` : '')
  )

  // @todo: every n minutes, clear the datalayer to avoid bloat for long running SPA/APP

  watch(
    () => config.tenant,
    (newTenant) => {
      if (newTenant) {
        if (additionalAccounts.length && additionalAccounts[0].tagId !== newTenant.gaMeasurementId) {
          // Update the GA configuration with the new tenant ID.  Don't use the configure
          // method as it adds duplicate event listeners to the router
          //@todo; this still sends data to the old measurementIDs even after a reset.  Needs more work to
          // property clear or reset the entire thing.
          window.dataLayer.push(function () {
            this.reset()
          })
          query('config', import.meta.env.VITE_GA_MEASUREMENT_ID)
          if (newTenant.gaMeasurementId) {
            query('config', newTenant.gaMeasurementId)
            console.log('Google Analytics configured with new tenant ID:', newTenant.gaMeasurementId)
          }
          console.log(window.dataLayer)
        }
      }
    },
    { deep: true }
  )
}

export default Boot
